export default __webpack_public_path__ + "static/header-logo-ciso-6cff7c693b610e7a5802748d311161c3.png";